// src/pages/Juegos.js
import React from 'react';
import RandomNumberGenerator from '../Funciones/RandomNumberGenerator';

const Juegos = () => 
    <div>
<div>
    <p className="m-2"><b>N°1</b> Cargar Tabla excel</p>
    <div className="bg-light mx-auto px-2 border border-2 border-primary" style={{width:"950px", height:"630px"}} >
      <div style={{width:"100%",height:"100%",padding:"1px 0"}}>
         <RandomNumberGenerator/>
      </div>
    </div>
</div>
<hr className="mt-3 mb-2"/>
 {/*---------------------------------------------------------------------------------------- */}
 <div>
    <p className="m-2"><b>N°2</b> Buscar Dni</p>
    <div className="bg-light mx-auto px-2 border border-2 border-primary" style={{width:"950px", height:"630px"}} >
      <div style={{width:"100%",height:"100%",padding:"1px 0"}}>
         
      </div>
    </div>
</div>
<hr className="mt-3 mb-2"/>
 {/*---------------------------------------------------------------------------------------- */}
</div>;  
export default Juegos;